module.exports = __webpack_public_path__ + "img/logo.81d42905.png";